import React, { useEffect, useState } from "react";
import { getPartidos, deletePartido } from "../api/partidosVoley";
import { addResultado, deleteResultado, getResultados } from "../api/resultadosVoley";
import { updateEquipos } from "../api/equiposVoley";
import DataTable from "./DataTable";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Box,
  Typography,
  Grid
} from "@mui/material";
import { columns } from "../dataTableConfig/resultadosVoley";
import { categories } from "../data/categoriesVoley";
import { getPointsConfig } from "../api/pointsConfig";

export default function AgregarResultadoVoley() {
  const [partidos, setPartidos] = useState([]);
  const [partidosSeleccionables, setPartidosSeleccionables] = useState([]);
  const [resultado, setResultado] = useState({});
  const [rows, setRows] = useState([])
  const [isEditing, setIsEditing] = useState(false)
  const [pointsConfig, setPointsConfig] = useState([])
  const [isButtonDisable, setisButtonDisable] = useState(false)
  useEffect(() => {
    getPartidos().then((res) => {
      setPartidos(res);
      setPartidosSeleccionables(res);
    });

    getResultados().then((res) => {
      setRows(res);
    });

    getPointsConfig().then(res => {
      setPointsConfig(res)
     console.log('PointsConfig',res)
    })
  }, []);

  const selectCategory = (e) => {
    const newListPartidos = partidos.filter(
      (partido) => partido.category === e.target.value
    );
    setPartidosSeleccionables(newListPartidos);
  };

  const selectPartido = (id) => {
    const partidoSelected = partidos.filter((partido) => partido.id == id);
    setResultado({
      ...partidoSelected[0],
      sets_local: null,
      sets_visitante: null,
    });
  };

  const handleChange = (e) => {
    setResultado({ 
      ...resultado, 
      [e.target.name]: e.target.value,
      id: resultado.id != null ? resultado.id : Math.random()
    });
  };


  const submitResultado = async () => {
    const resultadoActualizado = calcularSetsGanados(resultado)
    const sumaPuntos = pointsConfig.filter(res => res.category == resultado.category)
    console.log(sumaPuntos)
    if(sumaPuntos[0].sumaPuntos) {
    // await updateEquipos(resultado, isEditing);
        await updateEquipos(resultadoActualizado, isEditing);

    }
    
    await addResultado(resultadoActualizado);
    await deletePartido(resultadoActualizado.id);
    
    const existingIndex = rows.findIndex(row => row.id === resultadoActualizado.id);
    if (existingIndex !== -1) {
      // Si el objeto ya existe, reemplazarlo en su posición actual
      const updatedRows = [...rows];
      updatedRows[existingIndex] = resultadoActualizado;
      setRows(updatedRows);
    } else {
      // Si el objeto no existe, agregarlo al inicio del array
      setRows(oldRows => [resultadoActualizado, ...oldRows]);
    }
    setIsEditing(false)
    setResultado({
      sets_visitante: "",
      equipo_local_id: null,
      cancha_id: "",
      hora: "",
      equipo_local: "",
      fecha: "",
      cancha: "",
      equipo_visitante_id: null,
      id: null,
      sets_local: "",
      category: "",
      equipo_visitante: "",
    })
    setisButtonDisable(false)
  };

  const handleEdit = (data) => {
    setResultado(data)
    setIsEditing(true)
  }

  const handleDelete = async(data) => {
    await deleteResultado(data.id)
    const nuevosResultados = rows.filter(row => row.id != data.id)
    setRows(nuevosResultados)
  }


  function calcularSetsGanados(resultado) {
  let sets_local = 0;
  let sets_visitante = 0;

  // Recorremos hasta 5 sets (por compatibilidad futura)
  for (let i = 1; i <= 5; i++) {
    const local = parseInt(resultado[`set_local_${i}`]);
    const visitante = parseInt(resultado[`set_visitante_${i}`]);

    // Si alguno no está definido, se ignora
    if (isNaN(local) || isNaN(visitante)) continue;

    if (local > visitante) sets_local++;
    else if (visitante > local) sets_visitante++;
  }

  // Retorna un nuevo objeto actualizado
  return {
    ...resultado,
    sets_local,
    sets_visitante,
  };
}
  return (
    <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px"
    }}>
      <Typography variant="h5" sx={{ textAlign: "center", marginBottom: 5 }}>
        Agregar resultado Voley
      </Typography>
      <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
          <InputLabel>Categoría</InputLabel>
          {resultado.id != null ?
            (<TextField
              id="puntos"
              name="categoria"
              variant="outlined"
              value={resultado.category}
              disabled
              fullWidth
          />) 
          : 
          (
            <Select
              id="demo-simple-select"
              name="category"
              label="Categoría"
              defaultValue="Seleccionar"
              value={resultado.category || ""}
              onChange={(e) => selectCategory(e)}
              fullWidth
            >
              <MenuItem disabled value="">
              Seleccionar
              </MenuItem>
              {categories.map(category => (
                <MenuItem key={category.name} value={category.name}>{category.name}</MenuItem>
              ))}
            </Select>
          )}
        </Grid>
        {resultado.id != null ?
          (
            <Grid item xs={12} sm={6}>
                <InputLabel>Seleccionar Partido</InputLabel>
                <TextField
                    id="puntos"
                    name="partido"
                    variant="outlined"
                    value={`${resultado.equipo_local} vs ${resultado.equipo_visitante}`}
                    disabled
                    fullWidth
                />
            </Grid>
          ) : 
          (
            <Grid item xs={12} sm={6}>
              <InputLabel>Seleccionar Partido</InputLabel>
              <Select
                  id="demo-simple-select"
                  name="partidos"
                  label="Partidos"
                  defaultValue="Seleccionar"
                  onChange={(e) => selectPartido(e.target.value)}
                  fullWidth
              >
                  <MenuItem disabled value="Seleccionar">
                      Seleccionar
                  </MenuItem>
                  {partidosSeleccionables.map((partido) => (
                      <MenuItem value={partido.id} key={partido.id}>
                          {partido.equipo_local} vs {partido.equipo_visitante}
                      </MenuItem>
                  ))}
              </Select>
            </Grid>
          )
        }

        <Grid item xs={12}>
  <InputLabel>Sets</InputLabel>

  {[0, 1, 2].map((index) => (
    <Grid container spacing={2} key={index} sx={{ mt: 1 }}>
      <Grid item xs={12} sm={6}>
        <TextField
          label={`Set ${index + 1} - ${resultado.equipo_local}`}
          name={`set_local_${index + 1}`}
          type="number"
          value={resultado[`set_local_${index + 1}`] || ""}
          onChange={(e) => handleChange(e)}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label={`Set ${index + 1} - ${resultado.equipo_visitante}`}
          name={`set_visitante_${index + 1}`}
          type="number"
          value={resultado[`set_visitante_${index + 1}`] || ""}
          onChange={(e) => handleChange(e)}
          fullWidth
        />
      </Grid>
    </Grid>
  ))}
</Grid>

      </Grid>
      <Box mt={3} textAlign="center" width="100%" display="flex" justifyContent="center" gap={2}>
        <Button
          sx={{ width: "200px" }}
          variant="contained"
          onClick={() => {
            submitResultado()
            setisButtonDisable(true)
          }}
          disabled={isButtonDisable}
        >
          Cargar Resultado
        </Button>
        <Button
          sx={{ width: "200px" }}
          variant="outlined"
          onClick={() => setResultado({
            id: null,
            category: "",
            equipo_local: "",
            equipo_visitante: "",
            sets_local: "",
            sets_visitante: ""
          })}
        >
          Agregar Nuevo
        </Button>
      </Box>

      <DataTable columns={columns} rows={rows} setData={(data) => handleEdit(data)} onDelete={(data) => handleDelete(data)}/>
    </Box>
  );
}
